import { useState } from 'react';
import './Blog.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/Popup';
import Image from './5.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <div className='blogPageMainScreen'>
        <div className='blogPageMainScreenContent'>
          <span className='blogPageMainScreenBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path
                d='M7.9987 12.6667L3.33203 7.99999M3.33203 7.99999L7.9987 3.33333M3.33203 7.99999H12.6654'
                stroke='#3A6376'
                stroke-width='1.33'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Back to Articles
          </span>
          <h1 className='blogPageMainScreenTitle'>How to be Successful Working with Millennials</h1>
          <span className='blogPageMainScreenDate'>November 26, 2025</span>
          <div className='blogPageMainScreenImage'>
            <img src={Image} />
          </div>
        </div>
      </div>
      <div className='blogPageContent'>
        <p>
          A recent Gallup report titled, How Millennials Want to Work and Live revealed some interesting findings on millennials
          and their habits. For example, millennials were found to be the least engaged generation, with only 29% saying they are
          “emotionally and behaviorally connected to their job and company.” While these numbers aren’t far off from other
          generations (Gen Xers reported 32% engagement, Baby Boomers reported 33%), what millennials are willing to do about it
          differs greatly. Gallup’s report highlighted that:
        </p>
        <ul>
          <li>21% of millennials changed jobs within the last year (three times the number of non-millennials)</li>
          <li>
            50% of millennials strongly agree that they plan to be working at the same company a year from now (60% of
            non-millennials said the same)
          </li>
          <li>60% of millennials are open to a different job opportunity (15 percentage points higher than non-millennials)</li>
          <li>
            36% of millennials plan on looking for a new job outside of their current organization within the next 12 months in
            the job market improves (only 21% of non-millennials said the same)
          </li>
        </ul>
        <p>
          So, what does this all mean? Inc. took this information and provided the following tips for employers, millennials, and
          employees alike:
        </p>
        <h3>TIPS FOR EMPLOYERS</h3>
        <p>
          Millennial workers are not satisfied with their current work situation. Many companies spend an enormous amount of money
          and manpower on attracting new, high-quality talent, but then drop the ball when it comes to keeping that talent around.
          Here’s what millennials want you to provide them:
        </p>
        <ul>
          <li>Consistent, high-quality communication</li>
          <li>Sincere praise when appropriate</li>
          <li>Flexibility</li>
          <li>Transparency</li>
          <li>New challenges</li>
          <li>Freedom</li>
          <li>Opportunities to grow</li>
        </ul>
        <h3>TIPS FOR MILLENNIALS</h3>
        <p>
          You have a great opportunity to stand out among your peers. Because most millennials are disengaged and indifferent,
          deciding to renew your interest in your work could lead to great opportunities. For example, if your manager has noticed
          how unmotivated your team is, come up with a way to help get your team motivated again. Not only will this give you
          leverage when asking for a raise or benefits, but it may also lead to the fulfillment of a few of the desires we touched
          on above. If there are things you’d like to change about your job, don’t just live with it. Brainstorm a solution that
          would make you happier, and won’t require your company to move mountains to implement. Chances are your manager will be
          impressed with your initiative and let you try it out.
        </p>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default BlogPage;
